import React from 'react';

import { PreviewHeader } from 'src/components/atoms/PreviewHeader';
import { ContentPageProps } from '../../../types/PageProps';
import { ContentBlocks } from '../../atoms/ContentBlocks';
import { HiddenPageTitle } from '../../atoms/HiddenPageTitle';
import { Seo } from '../../atoms/Seo';

export const RibbonsPage = ({
  pageMetadata: { isPreview },
  pageContent: { title, seo, blocks },
}: ContentPageProps) => (
  <>
    <Seo {...seo} />
    <HiddenPageTitle>{title}</HiddenPageTitle>
    {isPreview && <PreviewHeader />}
    {blocks ? <ContentBlocks blocks={blocks} isPreview={isPreview} /> : null}
  </>
);
